export default {
    LOAD_PRODUCT_SUBCATEGORIES (state, productsubcategories) {
        state.items = productsubcategories
    }
}